import { Info } from 'lucide-react';
import { useId } from 'react';
import { clsx } from 'clsx';

interface InfoTooltipProps {
  children: string;
  className?: string;
  label?: string;
}

/**
 * Keeps optional guidance available without adding persistent copy to a form
 * or settings surface. The tooltip is also shown when the icon receives
 * keyboard focus.
 */
export const InfoTooltip = ({ children, className, label = 'More information' }: InfoTooltipProps) => {
  const tooltipId = useId();

  return (
    <span className={clsx('group relative inline-flex align-middle', className)}>
      <button
        type="button"
        aria-label={label}
        aria-describedby={tooltipId}
        className="inline-flex h-4 w-4 items-center justify-center rounded-full text-content-muted transition-colors hover:text-content-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
      >
        <Info aria-hidden="true" className="h-4 w-4" strokeWidth={2} />
      </button>
      <span
        id={tooltipId}
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 w-max max-w-xs -translate-x-1/2 rounded-md bg-content-primary px-2.5 py-1.5 text-left text-xs leading-5 text-surface-base opacity-0 shadow-lg transition-opacity group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {children}
      </span>
    </span>
  );
};

export default InfoTooltip;
